module.exports = __webpack_public_path__ + "static/media/guitarrist-boy.2a52bb06.png";